import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux';
import {getInvoiceTDS} from '../../../helper/Api';
import DataTable from 'react-data-table-component';
// import {AddCommasToAmount} from "../../../helper/Utils";
import {useLocation} from "react-router-dom";

const RoyaltyList = ({setSelectednvoice, fromDate, toDate, searchStr, dateColumn}) => {
    const {authData} = useSelector((state) => state.authData);
    // const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    let {state} = useLocation();
    const [data, setData] = useState(state && state.data ? state.data : []);

    const fetchChallans = async (fromDate, toDate, searchStr) => {
        try {
            const data = await getInvoiceTDS({
                from_date: fromDate,
                to_date: toDate,
                royalty: true, searchStr
            });
            if (data.data.status) {
                setData(data.data.list);
            }
        } catch (error) {
            setData([]);
        }
    }

    useEffect(() => {
        fetchChallans();

    }, [])

    useEffect(() => {
        fetchChallans(fromDate, toDate, searchStr);
    }, [fromDate, toDate, searchStr])


    const customStyles = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    };

    const columns = [
        {
            name: 'Invoice No',
            selector: (row) => row.invoice_no,
            wrap: true,
            sortable: true,
            width: "150px",
        },
        {
            name: 'Invoice Date',
            selector: (row) => row.invoice_date,
            wrap: true,
            sortable: true,
            width: "150px",
        },
        {
            name: 'Beneficiary\n' +
                'Name',
            selector: (row) => <b>{row.company_name || ''}</b>,
            sortable: true,
            wrap: true,
            width: "200px"
        },
        {
            name: 'Approval\n' +
                'Type',
            selector: (row) => row.payment_type === '1' ? "FULL PAYMENT" : row.payment_type === '2' ? 'PART PAYMENT' : '',
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'Voucher No',
            selector: (row) => row.voucher_no,
            sortable: true,
            width: "150px",
            right: false
        },
        {
            name: 'Voucher\n' +
                'Date',
            selector: (row) => row.voucher_date,
            sortable: true,
            width: "150px",
            right: false
        }, {
            name: 'Transaction\n' +
                'Date',
            selector: (row) => <b>{row.amount || ''}</b>,
            sortable: true,
            width: "150px",
            right: false
        },
        {
            name: 'Taxable\n' +
                'Amount',
            selector: (row) => <b>{row.taxable_amount || ''}</b>,
            sortable: true,
            width: "150px",
            right: false
        },
        {
            name: 'INVOICE\n' +
                'AMOUNT',
            selector: (row) => <b>{row.payable_amount || ''}</b>,
            sortable: true,
            width: "150px",
            right: false
        }, {
            name: 'INVOICE\n' +
                'Amount\n' +
                'Sanctioned',
            selector: (row) => <b>{row.sanction_amount || ''}</b>,
            sortable: true,
            width: "150px",
            right: false
        }, {
            name: 'Royalty Amount',
            selector: (row) => <b>{row?.royalty_amount || ''}</b>,
            sortable: true,
            width: "150px",
            right: false
        },
        {
            name: 'Details',
            width: "200px",
            selector: (row) => row?.invoice ?
                <a href={row?.invoice} target="_blank" rel="noreferrer">Attachment</a> : '',
            sortable: false,
        },
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        // setCurrentPage(1); // Reset to the first page when rows per page changes
    };

    const handleSelectedChange = ({selectedRows}) => {
        setSelectednvoice(selectedRows)
    }

    // const calculateTotalAmount = (propertyName) => {
    //     let total = 0;
    //     data.forEach((row) => {
    //         const depositAmount = Number(parseFloat(row[propertyName]));
    //         if (!isNaN(depositAmount)) {
    //             total += depositAmount;
    //         }
    //     });
    //     return total.toFixed(2);
    // };

    // const totalInvoiceAmount = calculateTotalAmount('nps');

    // const footerRow = {
    //     isFooter: true,
    //     selectableRowsSingle: false,
    //     invoice_no: <b>Total</b>,
    //     nps: <b>{AddCommasToAmount(totalInvoiceAmount)}</b>,
    // };

    return (
        <div>
            <DataTable
                customStyles={customStyles}
                className="dataTables_wrapper"
                selectableRows={authData.user.user_type === 'l1'}
                onSelectedRowsChange={handleSelectedChange}
                columns={columns}
                data={data}
                fixedHeader
                fixedHeaderScrollHeight="600px"
                pagination
                paginationPerPage={rowsPerPage}
                paginationTotalRows={data.length}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </div>
    )
}

export default RoyaltyList
